import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import ContainedImage from '../contained-image';
import { faMicrophone as mic } from "@fortawesome/pro-solid-svg-icons";
import {faMicrophone} from "@fortawesome/pro-regular-svg-icons";
import LoadingSpinner from '../loader';
import Hexagon from "../hexagon";

const RecordingContainer = styled.div`
    height: 100%;
    width: 100%;  
    background: #F1F1F1;
    display: flex;
    justify-content: center;
    align-items: center;
    >:first-child {
        cursor: pointer;
    }
`;


export const MicIcon = styled.div`
     height: 100%;
    width: 100%;

    max-height: 4rem;
    max-width: 4rem;
    background-image: url(https://storage.cloud.google.com/telbee-assets/vox-button-bg.png);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    
    display: flex;
    align-items: center;
    justify-content: center;
`;


export const Mic = ({ onClick, style }) => <ContainedImage style={style} src={`https://storage.cloud.google.com/telbee-assets/vox-button-bg.png`} onDragStart={() => false} onClick={onClick} alt="mic" />;
export const Arrow = () => <ContainedImage src={`${process.env.PUBLIC_URL}/img/down-arrow.svg`} id="down-arrow" onDragStart={() => false} alt="click here" />;

export default class RecordButton extends Component {
    static propTypes = {
        onClick: PropTypes.func,
        arrow: PropTypes.bool
    }

    render() {
        const { arrow, onClick, style, common, icon, micPermission } = this.props;
        return (
            <RecordingContainer onClick={onClick} style={style}>
                    <Hexagon common={common} icon={icon ? icon : faMicrophone} onClick={onClick} micPermission={micPermission}/>
                {arrow && <Arrow />}
            </RecordingContainer>
        )
    }
}
